import { useState } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { featuredReviews } from "@/data/reviews";
import { properties } from "@/data/site";

const nameForSlug = (slug) => properties.find((p) => p.slug === slug)?.name || "Martelli Rentals";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const list = featuredReviews;
  if (!list.length) return null;
  const r = list[idx];
  const move = (d) => { setExpanded(false); setIdx((idx + d + list.length) % list.length); };
  const isLong = r.fullText.length > r.excerpt.length + 4;

  return (
    <section className="py-24 md:py-32 bg-brand-ivory/50">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">Recensioni</p>
          <h2 className="font-heading font-light text-4xl md:text-5xl text-brand-black">Le parole dei nostri ospiti</h2>
          <p className="mt-4 text-brand-brown text-lg">Recensioni reali tratte dalle nostre esperienze di ospitalità.</p>
          <p className="mt-2 text-xs text-brand-brown/70">Recensioni reali trascritte da piattaforme di prenotazione.</p>
        </Reveal>

        <div data-testid="testimonial-slider" className="mt-12 bg-white border border-brand-ivory rounded-2xl p-8 md:p-12">
          <div className="flex justify-center gap-1 mb-5">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className={`w-5 h-5 ${i < r.rating ? "fill-brand-gold text-brand-gold" : "text-brand-ivory"}`} />
            ))}
          </div>
          <p className="font-heading text-2xl md:text-3xl text-brand-black leading-relaxed italic">
            “{expanded ? r.fullText : r.excerpt}”
          </p>
          {isLong && (
            <button data-testid="review-readmore" onClick={() => setExpanded((v) => !v)} className="mt-3 text-sm text-brand-olive underline underline-offset-4">
              {expanded ? "Riduci" : "Leggi di più"}
            </button>
          )}
          <div className="mt-6 text-sm text-brand-brown">
            <span className="font-medium text-brand-black">{r.guestName}</span> · {nameForSlug(r.propertySlug)}
            <div className="text-xs mt-1 opacity-70">{r.stayDate} — {r.language.toUpperCase()}</div>
          </div>
          <div className="flex justify-center gap-3 mt-8">
            <button data-testid="testimonial-prev" onClick={() => move(-1)} aria-label="Precedente" className="w-10 h-10 rounded-full border border-brand-ivory flex items-center justify-center hover:bg-brand-ivory transition-colors">
              <ChevronLeft className="w-5 h-5 text-brand-brown" />
            </button>
            <button data-testid="testimonial-next" onClick={() => move(1)} aria-label="Successivo" className="w-10 h-10 rounded-full border border-brand-ivory flex items-center justify-center hover:bg-brand-ivory transition-colors">
              <ChevronRight className="w-5 h-5 text-brand-brown" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
